<template>
  <div class="honer">
    <div style="display: flex; align-items: flex-end; padding: 5px 0 0px 20px">
      <h2 style="margin-top: 10px;">
        宣传报道列表
        <span style="font-size: 14px;margin-bottom:4px">(若无荣誉/宣传报道，则删除此条数据)</span>
        <span
          v-if="
            !isRed
              ? false
              : formerList != null
              ? currentList != formerList
              : false
          "
          style="color: red; font-size: 14px"
          >已修改</span
        >
      </h2>
    </div>
    <div class="sub">
      <el-button style="margin-bottom: 5px" type="primary" @click="add">添加报道信息</el-button>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div
        style="display: flex; flex-wrap: wrap"
        class="border"
        v-for="(item, index) in ruleForm.list"
        :key="index"
      >
        <p style="position: absolute; right: 25px; cursor: pointer " @click="del(index)">删除</p>
        <!-- {{ item.title }}--{{ thirdList ? thirdList[index].title : "" }} -->
        <el-form-item
          label="报道标题"
          :prop="'list.' + index + '.title'"
          :rules="rules.title"
          style="width: 70%"
        >
          <el-input v-model="item.title" placeholder="请输入标题"></el-input>
          <i
            class="el-icon-s-opportunity red"
            v-if="thirdList ? thirdList[index].title != item.title : false"
          ></i>
        </el-form-item>
        <!-- {{ item.source }} -->
        <el-form-item
          label="报道来源"
          :prop="'list.' + index + '.source'"
          :rules="rules.source"
        >
          <el-input v-model="item.source" placeholder="请输入来源"></el-input>
          <i
            class="el-icon-s-opportunity red"
            v-if="thirdList ? thirdList[index].source != item.source : false"
          ></i>
        </el-form-item>
        <!-- {{ item.time }} -->
        <el-form-item
          label="报道时间"
          :prop="'list.' + index + '.time'"
          :rules="rules.time"
        >
          <el-date-picker
            type="date"
            placeholder="报道时间"
            v-model="item.time"
            style="width: 100%"
            value-format="timestamp"
          ></el-date-picker>
          <!-- <i class="el-icon-s-opportunity red"></i> -->
        </el-form-item>
        <el-form-item
          label="报道链接"
          style="width: 70%"
          :prop="'list.' + index + '.link'"
          :rules="rules.link"
        >
          <!-- {{ item.link }} -->
          <el-input
            v-model="item.link"
            placeholder="请输入http:// ，https://开头地址"
          ></el-input>
          <!-- <i class="el-icon-s-opportunity red"></i> -->
        </el-form-item>
        <br />
        <el-form-item
          label="报道封面"
          style="width: 100%; margin-bottom: 20px"
          :prop="'list.' + index + '.imageUrl'"
          :rules="rules.imageUrl"
          class="w"
        >
          <div>
            <el-upload
              class="avatar-uploader"
              action="#"
              accept="image/*"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="(file, fileList) => {onChangeImgCopy(file, fileList, index)}"
            >
              <div
                style="display: flex; position: relative; margin-left: 8px"
                @click.stop
                v-for="(items, idx) in item.imageUrl"
                :key="idx"
              >
                <img :src="items" class="avatar" />
                <div class="file">
                  <i
                    class="el-icon-zoom-in"
                    @click="handlePictureCardPreview(items)"
                  ></i>
                  <i
                    class="el-icon-download"
                    @click="handleDownload(items)"
                  ></i>
                  <!-- </span> -->
                  <i class="el-icon-delete" @click="handleRemove(index,idx)"></i>
                </div>
              </div>
              <i
                v-if="item.imageUrl.length < 1"
                class="el-icon-plus avatar-uploader-icon"
                style="margin-left: 8px"
              ></i>
            </el-upload>
            <div
              class="annotations"
              style="position: absolute; white-space: nowrap; line-height: 1.5"
            >
              请选择JPG/PNG格式的尺寸为135px:91px的报道封面
            </div>
          </div>
        </el-form-item>
      </div>
      <div class="sub btnDiv" style="display: flex; margin-bottom: 0">
        <el-button
          type="primary"
          ref="rongyu"
          @click="upper('ruleForm')"
          class="btn"
          >上一页</el-button
        >
        <div style="display: flex">
          <el-button
            type="text"
            style="color: #000"
            v-if="
              $route.path == '/taggingManage/personal-center' &&
              shifoubutongguo == 6
            "
            >驳回原因
            <i
              class="el-icon-warning-outline"
              style="color: red"
              @click="notPush"
              v-points="2000"
            ></i>
          </el-button>
          <div v-if="$route.path == '/taggingManage/personal-center'">
            <el-button
              type="warning"
              v-points="2000"
              @click="submitForm('ruleForm', 1)"
              v-if="shifoutijiao"
              >保存草稿</el-button
            >
            <el-button
              type="primary"
              @click="submitForm('ruleForm', 2)"
              v-points="2000"
              >提交审核</el-button
            >
          </div>
          <div v-if="isPath">
            <el-button
              type="primary"
              v-if="tongguo&&(jcy_name==userInfo.jcy_name||userInfo.jcy_name=='江苏省')"
              @click="submitForm('ruleForm', 3)"
              v-points="2000"
              >审核通过</el-button
            >
            <el-button
              type="primary"
              v-if="songshen&&(jcy_name==userInfo.jcy_name||userInfo.jcy_name=='江苏省')"
              @click="submitForm('ruleForm', 4)"
              v-points="2000"
              >送审
              </el-button
            >
            <el-button
              type="primary"
              v-if="bohui&&(jcy_name==userInfo.jcy_name||userInfo.jcy_name=='江苏省')"
              @click="reject(1)"
              v-points="1000"
              >驳回</el-button
            >
            <el-button
              type="primary"
              @click="reject(2)"
              v-if="bufabu&&(jcy_name==userInfo.jcy_name||userInfo.jcy_name=='江苏省')"
              v-points="1000"
              >不发布</el-button
            >
            <el-button
              type="primary"
              @click="chehuis"
              v-if="chehui&&(jcy_name==userInfo.jcy_name||userInfo.jcy_name=='江苏省')"
              v-points="1000"
              >撤回</el-button
            >
            <el-button
              type="primary"
              v-if="fabu&&(jcy_name==userInfo.jcy_name||userInfo.jcy_name=='江苏省')"
              @click="submitForm('ruleForm', 5)"
              v-points="2000"
              >发布</el-button
            >
          </div>
        </div>
      </div>
    </el-form>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { updateUserinfo, checkUser } from "@/api/open";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  props: ["thirdList", "oneDate", "twoDate","msg"],
  data() {
    let validateInput = (rule, value, callback) => {
      // console.log(value.indexOf("http:"));
      if (value.indexOf("http://") != -1) {
        callback();
      } else if (value.indexOf("https://") != -1) {
        callback();
      } else {
        callback(new Error("请输入正确的http或https地址"));
      }
    };

    return {
      jcy_name:"",
      dialogImageUrl: "",
      dialogVisible: false, //查看图片弹窗使用
      currentList: [], //倒数第一次数据
      formerList: null, //倒数第二次数据
      list: 1,
      ruleForm: {
        list: [{ title: "", source: "", time: "", link: "", imageUrl: [] }],
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        source: [{ required: true, message: "请输入来源", trigger: "change" }],
        time: [{ required: true, message: "请选择时间", trigger: "change" }],
        link: [
          { required: true, message: "请输入链接", trigger: "blur" },
          { validator: validateInput, trigger: "blur" },
        ],
        imageUrl: [{ required: true, message: "请选择", trigger: "change" }],
      },
      tongguo: false,
      songshen: false,
      bohui: false,
      bufabu: false,
      chehui: false,
      fabu: false,
      isRed: false, //是否显示标红
      BH_y: "", //驳回原因
      reason: "", //回显不发布原因
      shifoutijiao: false, //是否提交审核
      shifoubutongguo: 0, //是否不通过\
      isPath: false,
      jcy1: "", //当前数据信息
      jcy2: "", //当前数据信息
      currentList: {}, //当条所有信息（赶时间，下策）
      isProvince: "", //是否省院
      imgUrlId: 0,
    };
  },
  computed: { ...mapGetters(["userInfo"]) },
  methods: {
    onChangeImgCopy(file,fileList,itemIdx) {
        // console.log(file)
        // console.log(fileList)
        // console.log(itemIdx)

        if (this.ruleForm.list[itemIdx].imageUrl.length >= 1) {
            this.$message.error("最多上传1张");
            return;
        }
      this.uploadImgToOss(file)
        .then((res) => {
          if (res.status == 200) {
            this.ruleForm.list[itemIdx].imageUrl.push(
              this.ossUrl + res.data.data
            );
          }
        })
        .catch((error) => {});
    },
    handlePictureCardPreview(file) {
      // console.log(file);
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    handleRemove(itemIdx,imgIdx) {
      this.ruleForm.list[itemIdx].imageUrl.splice(imgIdx, 1);
    },
    /////////////多图模式


    handleDownload(file) {
      var a = document.createElement("a");
      a.download = name || "pic";
      // 设置图片地址
      a.href = file;
      a.target = "_blank";
      a.click();
    },
    //删除
    del(index) {
      // console.log(index);
      this.ruleForm.list.splice(index, 1);
    },
    //提交审核
    sub() {
      console.log(this.GET_DATE(1));
      checkUser(this.GET_DATE(1)).then((res) => {
        if (res.code == 200) {
          this.$message.success("提交审核成功");
          console.log(this.ruleForm.list);
          this.$emit("propaganda", this.ruleForm.list);
          if (this.$route.path == "/taggingManage/look-advanced") {
            this.$router.push("/taggingManage/advanced");
          }
        }
      });
    },
    //审批通过
    approvePass() {
      checkUser(this.GET_DATE(2)).then((res) => {
        if (res.code == 200) {
          this.$message.success("审批通过成功");
          this.$emit("propaganda", this.ruleForm.list);
          if (this.$route.path == "/taggingManage/look-advanced") {
            this.$router.push("/taggingManage/advanced");
          }
        }
      });
    },
    //送审
    censorship() {
      checkUser(this.GET_DATE(3)).then((res) => {
        if (res.code == 200) {
          this.$message.success("送审成功");
          this.$emit("propaganda", this.ruleForm.list);
          if (this.$route.path == "/taggingManage/look-advanced") {
            this.$router.push("/taggingManage/advanced");
          }
        }
      });
    },
    //发布
    release() {
      console.log(this.GET_DATE(5));
      checkUser(this.GET_DATE(5)).then((res) => {
        if (res.code == 200) {
          this.$message.success("发布成功");
          this.$emit("propaganda", this.ruleForm.list);
          if (this.$route.path == "/taggingManage/look-advanced") {
            this.$router.push("/taggingManage/advanced");
          }
        }
      });
    },
    //撤回()
    chehuis() {
      checkUser(this.GET_DATE(6)).then((res) => {
        if (res.code == 200) {
          this.$message.success("撤回成功");
          this.$emit("propaganda", this.ruleForm.list);
          if (this.$route.path == "/taggingManage/look-advanced") {
            this.$router.push("/taggingManage/advanced");
          }
        }
      });
    },
    add() {
      this.ruleForm.list.push({
        title: "",
        source: "",
        time: "",
        link: "",
        imageUrl: [],
      });
    },
    submitForm(formName, val) {
      //val  1保存草稿 2提交审核  3审批通过 4送审  5发布
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          if (val == 1) {
            this.draft();
          } else if (val == 2) {
            this.sub();
          } else if (val == 3) {
            this.approvePass();
          } else if (val == 4) {
            this.censorship();
          } else if (val == 5) {
            this.release();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //上一页
    upper() {
      this.$emit("propaganda", "top");
    },
    subClick() {
      // console.log(122);
      this.$refs.baodao.$el.click();
    },
    //驳回（不发布）
    reject(val) {
      if (val == 1) {
        this.$prompt("请输入原因")
          .then(({ value }) => {
            // console.log(value);
            this.BH_y = value;
            console.log("确定");

            checkUser(this.GET_DATE(4, this.BH_y)).then((res) => {
              if (res.code == 200) {
                this.$message.success("驳回成功");
                this.$emit("propaganda", this.ruleForm.list);
                if (this.$route.path == "/taggingManage/look-advanced") {
                  this.$router.push("/taggingManage/advanced");
                }
              }
            });
          })
          .catch(() => {
            console.log("取消");
          });
      } else {
        checkUser(this.GET_DATE(6, this.BH_y)).then((res) => {
          if (res.code == 200) {
            this.$message.success("操作成功");
            this.$emit("propaganda", this.ruleForm.list);
            if (this.$route.path == "/taggingManage/look-advanced") {
              this.$router.push("/taggingManage/advanced");
            }
          }
        });
      }
    },
    //不发布原因
    notPush() {
      this.$alert(this.msg, {
        confirmButtonText: "确定",
        callback: (action) => {
          this.$message.success("关闭");
        },
      });
    },
    //通过
    pass() {
      // console.log("调接口");
    },
    //删除
    del(index) {
      this.ruleForm.list.splice(index, 1);
    },
    //保存草稿
    async draft() {
      // console.log(1);
      // console.log(JSON.stringify(this.userInfo.jobImg));
      let parmas = {
        id: this.userInfo.id,
        jcy1: this.userInfo.jcy1,
        jcy2: this.userInfo.jcy2,
        jcy3: this.userInfo.jcy3,
        jcy_id: this.userInfo.jcy_id,
        username: this.oneDate.name,
        sex: this.oneDate.sex,
        birth: this.oneDate.birthday,
        native_place: this.oneDate.place,
        introduction: this.oneDate.tinymceHtml,
        photo: this.oneDate.imageUrl,
        phone: this.userInfo.phone,
        job_photo: JSON.stringify(this.oneDate.jobImg),
        outlook: this.oneDate.outlook,
        position: this.oneDate.belonging,
        honor: JSON.stringify(this.twoDate),
        publicity: JSON.stringify(this.ruleForm.list),
        auth: this.userInfo.auth,
        reason: "", //驳回原因
        role: this.userInfo.role,
        state: 0,
        status: this.userInfo.status, //冻结不冻结
      };
      await updateUserinfo(parmas).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
        this.$emit("propaganda", this.ruleForm.list);
      });
    },
    getCurrentList(val) {
      if (val != null) {
        this.currentList = val;
        this.ruleForm.list = JSON.parse(val).reverse();
      }
    },
    getFormerListList(val) {
      if (val != null) {
        this.formerList = val;
      }
    },
    //按钮显示隐藏
    btnShow() {
      this.btn();
      //市区审核员
      if (this.userInfo.userLevel == "2" && this.$route.query.tabId == "1") {
        this.tongguo = true;
        this.songshen = true;
        this.bohui = true;
      } else if (
        (this.userInfo.userLevel == "2" && this.$route.query.tabId == "2") ||
        (this.userInfo.userLevel == "2" && this.$route.query.tabId == "3") ||
        (this.userInfo.userLevel == "2" && this.$route.query.tabId == "4") ||
        (this.userInfo.userLevel == "2" && this.$route.query.tabId == "5")
      ) {
        this.songshen = true;
      }
      //省审核员
      if (this.userInfo.userLevel == "1" && this.$route.query.tabId == "2") {
        this.fabu = true;
      } else if (
        this.userInfo.userLevel == "1" &&
        this.$route.query.tabId == "3"
      ) {
        //是省院
        if (this.isProvince == null || this.isProvince == "") {
          this.fabu = true;
          this.tongguo = true;
          this.bohui = true;
        } else {
          this.fabu = true;
          this.bufabu = true;
        }
        // this.fabu = true;
        // this.bohui = true;
        // this.tongguo = true;
        // this.bohui = true;
      } else if (
        this.userInfo.userLevel == "1" &&
        this.$route.query.tabId == "4"
      ) {
        this.fabu = true;
        this.chehui = true;
      } else if (
        this.userInfo.userLevel == "1" &&
        this.$route.query.tabId == "5"
      ) {
        this.fabu = true;
      }
    },
    //初始按钮状态
    btn() {
      this.tongguo = false;
      this.songshen = false;
      this.bohui = false;
      this.fabu = false;
      this.chehui = false;
      this.bufabu = false;
    },
    //请求接口的数据
    GET_DATE(actionId, bh) {
      let userLevel = "";
      if (
        (this.currentList.role == 3 && this.currentList.jcy2 == null) ||
        (this.currentList.role == 3 && this.currentList.jcy2 == "")
      ) {
        //管理员
        userLevel = "1"; //省管理员
      } else {
        userLevel = "2"; //市区管理员
      }
      let parmas = {
        action: actionId, //1提交审核2通过3送审4驳回5发布6不发布
        id: this.$route.query.id ? this.$route.query.id : this.userInfo.id,
        jcy1:
          this.currentList !== {} ? this.currentList.jcy1 : this.userInfo.jcy1,
        jcy2:
          this.currentList !== {} ? this.currentList.jcy2 : this.userInfo.jcy2,
        jcy3:
          this.currentList !== {} ? this.currentList.jcy3 : this.userInfo.jcy3,
        jcy_id:
          this.currentList !== {}
            ? this.currentList.jcy_id
            : this.userInfo.jcy_id,
        username: this.oneDate.name,
        sex: this.oneDate.sex,
        birth: this.oneDate.birthday,
        native_place: this.oneDate.place,
        introduction: this.oneDate.tinymceHtml,
        photo: this.oneDate.imageUrl,
        job_photo: JSON.stringify(this.oneDate.jobImg),
        // job_photo: this.oneDate.jobImg.join(','),
        phone: this.oneDate.phone,
        outlook: this.oneDate.outlook,
        position: this.oneDate.belonging,
        honor: JSON.stringify(this.twoDate),
        publicity: JSON.stringify(this.ruleForm.list),
        auth: this.currentList.auth,
        reason: bh, //驳回原因
        role:
          this.currentList !== {} ? this.currentList.role : this.userInfo.role,
        status:
          this.currentList !== {}
            ? this.currentList.status
            : this.userInfo.status, //冻结不冻结
        level: this.currentList !== {} ? userLevel : this.userInfo.userLevelId,
      };
      console.log(parmas);
      return parmas;
    },
    //判断按钮是否要隐藏
    isFOU(JCY2, JCY3) {
      this.isProvince = JCY2;
      if (JCY3 == "") {
        JCY3 = null;
      }
      if (
        this.$route.path == "/taggingManage/look-advanced" &&
        this.userInfo.userLevel == "1"
      ) {
        this.isPath = true;
      }else if (
              this.$route.path == "/taggingManage/look-advanced" &&
              this.userInfo.userLevel == "2"
      ) {
          this.isPath = true;
      } else if (
        this.$route.path == "/taggingManage/look-advanced" &&
        JCY2 == this.userInfo.jcy2
      ) {
        if (JCY3 !== null && this.userInfo.jcy3 == JCY3) {
          this.isPath = true;
        } else if (JCY3 !== null && this.userInfo.jcy3 !== JCY3) {
          this.isPath = false;
        } else if (JCY3 == null && this.userInfo.jcy3 == JCY3) {
          this.isPath = true;
        } else if (JCY3 == null && this.userInfo.jcy3 !== JCY3) {
          this.isPath = false;
        }
        // if (JCY3 == null || JCY3 == "") {
        //   this.isPath = true;
        // } else {
        //   if (this.userInfo.jcy3 == JCY3) {
        //     this.isPath = true;
        //   }
        // }
      }
      this.btnShow();
    },
  },
  watch: {
    thirdList(val) {
      this.ruleForm.list = JSON.parse(JSON.stringify(val));
    },
  },
  mounted() {
    if (this.$route.path != "/taggingManage/personal-center") {
      this.isRed = true;
    }
    console.log(sessionStorage.getItem("jcy_name"));
    if(sessionStorage.getItem("jcy_name")) {
      this.jcy_name=sessionStorage.getItem("jcy_name")
    }
    
  },
  activated() {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/index.scss";
.honer {
  height: 100%;
  width: 100%;

  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  border: 1px solid #e4e7ed;
  //   padding: 20px 20px;
  display: flex;
  flex-direction: column;
  .demo-ruleForm {
    padding: 0 0 0 10px;
    flex: 1;
    overflow-y: scroll;
  }
}
/deep/.el-input__inner {
  height: 36px;
}
.sub {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
  margin-right: 10px;
  /deep/.el-button {
    font-size: 0.875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    padding: 0.7rem 0.8rem;
    border: none;
  }
}
.el-form-item {
  width: 35%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 83px;
  height: 83px;
  line-height: 83px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}
.avatar {
  width: 83px;
  height: 83px;
  display: block;
}
.annotations {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
/deep/.el-form-item {
  margin-bottom: 15px;
}

.border {
    position: relative;
  border: 1px solid #e4e7ed;
  padding-top: 10px;
  margin-bottom: 5px;
}
.file {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background: #000;
  opacity: 0;
  // border-radius: 50%;
  i {
    color: #fff;
    margin-right: 5px;
    margin-left: 5px;
  }
}

.file:hover {
  opacity: 0.5;
}
// /deep/.el-upload {
  // display: flex;
// }
/deep/.el-dialog__header {
  border-bottom: none;
}
/deep/.el-dialog {
  margin-top: 50vh !important;
  transform: translate(0vh, -50%);
}
</style>